import { wacToken } from '@/libraries/design/foundations';

export const DesktopIcon = ({ isLargeImage }: { isLargeImage: boolean }) => {
	return (
		<svg
			className="width:full"
			height={isLargeImage ? '80' : '57'}
			viewBox="0 0 100 57"
			width={isLargeImage ? '142' : '100'}
			aria-hidden="true"
		>
			<path
				d="m8.28906 16c0-8.83654 7.16344-16 16.00004-16h51.4144c8.8366 0 16 7.16344 16 16v32.7804h-83.41444z"
				fill={wacToken('color.extended.blue200')}
			/>
			<path
				d="m12.1953 15.8984c0-6.62738 5.3726-11.99996 12-11.99996h51.6097c6.6274 0 12 5.37258 12 11.99996v32.6341h-75.6097z"
				fill={wacToken('color.neutral.light0')}
			/>
			<path
				d="m60.0044 26.2141h-5.7056l4.9414-2.8529-1.0853-1.8801-4.9413 2.8529 2.8522-4.941-1.88-1.0858-2.8523 4.941v-5.7052h-2.1704v5.7057l-2.8534-4.9415-1.8795 1.0853 2.8528 4.941-4.9413-2.8524-1.0853 1.8796 4.9414 2.8528h-5.7056v2.1706h5.7051l-4.9409 2.8528 1.0853 1.8801 4.9408-2.8523-2.8528 4.941 1.88 1.0852 2.8528-4.9415v5.7058h2.1705v-5.7053l2.8522 4.941 1.8801-1.0852-2.8528-4.9416 4.9413 2.8529 1.0853-1.8801-4.9409-2.8523h5.7051v-2.1705zm-9.7561 4.0369c-1.6366 0-2.9631-1.3265-2.9631-2.9631s1.3265-2.9632 2.9631-2.9632 2.9631 1.3266 2.9631 2.9632-1.3265 2.9631-2.9631 2.9631z"
				fill={wacToken('color.primary.blue')}
			/>
			<path
				d="m0 48.7109h100c0 4.3106-3.4944 7.8049-7.8049 7.8049h-84.39021c-4.31052 0-7.80489-3.4943-7.80489-7.8049z"
				fill={wacToken('color.extended.blue200')}
			/>
			<title id="desktop-icon">Desktop icon</title>
		</svg>
	);
};
